import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SetQuantitiesParams } from 'shared/schemas/shopify'
import { toast } from 'sonner'
import { GET_SHOPIFY_PRODUCTS_QUERY_KEY } from './useGetShopifyProducts'

export const useSetShopifyQuantity = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['set-shopify-quantity'],
    mutationFn: async (params: Omit<SetQuantitiesParams, 'locationId'>) => {
      const response = await fetch('/api/shopify/set_quantities', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      })

      if (!response.ok) {
        throw new Error('Failed to set Shopify quantity')
      }

      return response.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_SHOPIFY_PRODUCTS_QUERY_KEY] })
      toast.success('Shopify quantity set successfully')
    },
    onError: (error) => {
      console.error(error)
      toast.error('Failed to set Shopify quantity', { description: error.message })
    },
  })
}
